import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';

interface MediaProps {
    asset: SiteMedia;
}

export default function Media({ asset }: MediaProps): React.JSX.Element {
    if (asset.fields.media.url) {
        return (
            <ImageWrapper
                src={asset.fields.media.url}
                alt={asset.fields.media.altText}
                className="rteimage"
                optimizedWidth={asset.fields.media.width}
                optimizedHeight={asset.fields.media.height}
            />
        );
    }

    return <></>;
}
